
export class LinkHEUConventionExtension {
  selected: boolean;
}
